import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Payment from "../../pages/payment/Payment";
import { removeBasketItems } from "../../redux/feature/cartReducer";
import "../navbar/navbar.css";
import ModalItem from "./ModalItem";
import { Modal } from "react-bootstrap";
import { clickPaymentButton } from "../../redux/feature/paymentReducer";

const ModalBasket = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [showClearBasket, setShowClearBasket] = useState(false);
  const [animationClass, setAnimationClass] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const quantity = useSelector((state) => state.cart.totalQuantity);
  const cartItems = useSelector((state) => state.cart.itemsList);

  const itemsList = useSelector((state) => state.cart.itemsList);

  const clickPaymentBtn = useSelector(
    (state) => state.paymentButton.clickPaymentButton
  );

  //! Basket Total Price
  let total = 0;
  itemsList?.forEach((item) => {
    total += item.totalPrice;
  });

  //! Show Clear List
  const handleShowClearList = () => {
    setShowClearBasket(true);
    setAnimationClass("animate__animated animate__fadeInRight");
  };

  //! Close Clear List if modal closes
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => {
        setShowClearBasket(false);
      }, 300);
    }
  }, [isOpen]);

  //! Clear List Yes Button
  const handleYesClick = () => {
    setAnimationClass("animate__animated animate__fadeOutLeft");
    setLoading(true);
    setTimeout(() => {
      if (window.location.pathname === "/payment") {
        window.scrollTo(0, 0);
        dispatch(removeBasketItems());
        setShowClearBasket(false);
        setIsOpen(false);
        setLoading(false);
      } else {
        dispatch(removeBasketItems());
        setShowClearBasket(false);
        setIsOpen(false);
        setLoading(false);
      }
    }, 1500);
  };

  //! Clear List No Button
  const handleNoClick = () => {
    setAnimationClass("animate__animated animate__fadeOutLeft");
    setTimeout(() => {
      setShowClearBasket(false);
    }, 500);
  };

  //! Modal Close
  const handleCloseModal = () => {
    setIsOpen(!isOpen);
  };

  //! Changing the button
  //! when the Modal Payment button is pressed
  const handleClickPayment = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/payment");
      setIsOpen(false);
      dispatch(clickPaymentButton(true));
    }, 1000);
  };
  const handleClickHome = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      navigate("/");
      dispatch(clickPaymentButton(false));
      setIsOpen(false);
    }, 1000);
  };

  return (
    <>
      <div className="basket-div">
        <i
          onClick={handleCloseModal}
          className="basket-icon fas fa-regular fa-bag-shopping"
        ></i>
        {quantity > 0 && (
          <span className="basket-number animate__animated animate__fadeInLeft">
            {quantity}
          </span>
        )}
        <Modal
          className={`modalBasket`}
          show={isOpen}
          onHide={handleCloseModal}
        >
          {loading && (
            <div className="modal-loading">
              <span className="modal-loaderGif"></span>
            </div>
          )}
          <h6 className="modal-title text-center my-3">Shopping Cart</h6>

          <Modal.Title>
            <button
              onClick={handleCloseModal}
              type="button"
              className="mobile-modal-close-button"
            >
              <i className="fas fa-times"></i>
            </button>
          </Modal.Title>

          <Modal.Body className="modalBasketBody">
            {cartItems.length < 1 ? (
              <div className="text-center mt-5">
                <h6>Shopping List is Empty</h6>
              </div>
            ) : (
              <>
                {total > 0 && (
                  <div>
                    <h6 className="total-price mb-4">
                      Total Price
                      <span>${total?.toFixed(2)}</span>
                    </h6>
                  </div>
                )}

                {itemsList?.map((item) => (
                  <ModalItem
                    key={item?.id}
                    id={item?.id}
                    image={item?.image}
                    title={item?.title}
                    price={item?.price}
                    quantity={item?.quantity}
                    totalPrice={item?.totalPrice}
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    showDelete={showDelete}
                    setShowDelete={setShowDelete}
                  />
                ))}
                <div className="modal-buttons">
                  {clickPaymentBtn ? (
                    <button onClick={handleClickHome} className="home-btn">
                      Home
                      <i className="home-icon fas fa-light fa-home "></i>
                    </button>
                  ) : (
                    <button
                      onClick={handleClickPayment}
                      className="payment-btn"
                    >
                      Payment
                      <i className="pay-btn fas fa-regular fa-credit-card"></i>
                    </button>
                  )}

                  <button
                    className="clear-basket-btn"
                    onClick={handleShowClearList}
                  >
                    Clear List
                    <i className="trash-btn fas fa-solid fa-trash-can"></i>
                  </button>
                  {showClearBasket && (
                    <div className={`clear-list-buttons ${animationClass}`}>
                      <h6 className="text-center clear-list-buttons-title">
                        ARE YOU SURE?
                      </h6>
                      <div className="yes-no-buttons">
                        <button className="me-1" onClick={handleYesClick}>
                          Yes
                        </button>
                        <button className="ms-1" onClick={handleNoClick}>
                          No
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </>
            )}
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default ModalBasket;
